import axios from "axios";

const IconWrapper = {
    name: 'CollectionIconWrapper',
    data() {
        return {
            selected: null,
            markers: null,
        }
    },
    props: ['collection'],
    emits: ['changed'],
    inject: ['notyf'],
    methods: {
        listener(e) {
            if (this.collection == null) return;

            this.markers.push(e)
            this.addMarker(e)
        },

        addMarker(marker) {
            if (this.collection == null) return;

            axios.patch(`/collections/${this.collection.id}/markers`, {
                marker: marker.id,
            })
                .then(response => {
                    if (response.code >= 200) {
                        this.notyf.success('Added Successfully...');
                    }
                })
                .catch(error => {
                    // payment needed
                    if (error.response.code == 402) {
                        this.notyf.error('Payment Required to use feature');
                        return
                    }

                    if (error.response.code == 422) {
                        this.notyf.error('The data sent to the server was not what was expected, the marker was not added');
                        return
                    }

                    this.notyf.error('Error processing request to add icon')
                })
        },

        removeMarker(marker) {
            if (this.collection == null) return;

            let filtered = this.markers.map(value => value.id).indexOf(marker.id);

            this.markers.splice(filtered, 1)

            axios.post(`/collections/${this.collection.id}/markers`, {
                marker: marker.id,
                _method: 'DELETE'
            })
                .then(response => {
                    if (response.code >= 200) {
                        this.notyf.success('Added Successfully...');
                    }
                })
                .catch(error => {
                    // payment needed
                    if (error.response.code == 402) {
                        this.notyf.error('Payment Required to use feature');
                        return
                    }

                    if (error.response.code == 422) {
                        this.notyf.error('The data sent to the server was not what was expected, the marker was not added');
                        return
                    }

                    this.notyf.error('Error processing request to add icon')
                })
        }
    },

    mounted() {
        this.markers = this.collection.markers
    },

    render() {

        return this.$scopedSlots.default({
            listener: this.listener,
            markers: this.markers,
            removeMarker: this.removeMarker,
        });
    }
}

export default IconWrapper;
